export const extractETag = (etag: string) => etag.match(/"([^"]+)"$/)?.[1];
